import { z } from 'zod';

export const deleteSocialChannelV1RequestSchema = z.object({
  channelId: z.number(),
});

export type IDeleteSocialChannelV1Request = z.infer<typeof deleteSocialChannelV1RequestSchema>;
